import { Controller } from "@hotwired/stimulus"

// Says where a movement's date sits against the entity's snapshots, as the
// date changes: before the first snapshot on or after it, or since the latest.
// The wording matches CapHelper#cap_snapshot_position, which renders the
// first note server-side.
export default class extends Controller {
  static targets = ["date", "note"]
  static values = { snapshots: Array } // [{ asAt: "2026-09-16", label: "16 Sep 2026" }], oldest first

  connect() {
    this.update()
  }

  update() {
    const date = this.dateTarget.value
    const snapshots = this.snapshotsValue
    if (!date || snapshots.length === 0) {
      this.noteTarget.textContent = ""
      return
    }

    const after = snapshots.find((snapshot) => snapshot.asAt >= date)
    this.noteTarget.textContent = after
      ? `Before the ${after.label} snapshot: doesn't change the cap table.`
      : `Since the ${snapshots[snapshots.length - 1].label} snapshot: changes the cap table.`
  }
}
